import { FormattedMessage, useIntl } from 'react-intl'
import type { DialogState } from 'ariakit/dialog'
import { csx, ModalContent, Paragraph } from '@vtex/admin-ui'
import { CustomModal } from '@/components/CustomModal'

type InactiveItemModalProps = {
  state: DialogState
}

export const InactiveItemModal = ({ state }: InactiveItemModalProps) => {
  const { formatMessage } = useIntl()

  return (
    <CustomModal
      title={formatMessage({
        id: 'admin/admin.catalog.pending-status-card-heading',
        defaultMessage: 'Unavailable product',
      })}
      state={state}
      size="small"
    >
      <ModalContent className={csx({ textAlign: 'center' })}>
        <Paragraph>
          <FormattedMessage
            id="admin/admin.catalog.pending-status-card-description"
            defaultMessage="Check if this product has all the <b>required information</b>, <b>prices</b>, <b>inventory</b>, and <b>logistics settings</b>."
            values={{ b: (str) => <strong>{str}</strong> }}
          />
        </Paragraph>
      </ModalContent>
    </CustomModal>
  )
}
